import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { AuditTemplateDetailsModel } from 'app/audit-template/models/audit-template-details.model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-audit-template-list',
  templateUrl: './audit-template-list.component.html',
  styleUrls: ['./audit-template-list.component.css']
})
export class AuditTemplateListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    auditTemplates: AuditTemplateDetailsModel[];
    auditTemplateList: AuditTemplateDetailsModel[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;

    constructor(
        private auditTemplateService: AuditTemplateService,
        private fb: FormBuilder,
        private sortService: SortService
    ) { }

  ngOnInit() {
    this.headerTitle = { title: 'Audit Templates' }

    this.auditTemplateService.getAll().subscribe(
        result => {
            this.auditTemplates = result;
            this.auditTemplateList = result;
        },
        error => this.errors = error.errorList
    );

    this.filterTextControl = this.fb.control('');
    this.filterForm = this.fb.group({
        filterText: this.filterTextControl
    });

    this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
        this.auditTemplateList = this.sortService.filterAndSortlist(this.auditTemplates, newValue, this.lastSort);
    });
  }

}
